import type { Chart } from "../chart/Chart";
import { formatPrice, formatDateTime } from "../chart/util";

export class Legend {
  private el: HTMLElement;
  private symbol: string;
  private tfLabel = "";

  constructor(el: HTMLElement, symbol: string) {
    this.el = el;
    this.symbol = symbol;
  }

  setTimeframe(label: string) {
    this.tfLabel = label;
  }

  update(chart: Chart) {
    const data = chart.data;
    if (!data) return;
    let idx = chart.hoverIndex;
    if (idx < 0) {
      // last resident visible bar
      const [lo, hi] = chart.viewport.visibleRange();
      idx = hi - 1;
      while (idx >= lo && !isFinite(data.openAt(idx))) idx--;
    }
    const bar = idx >= 0 ? data.barAt(idx) : null;
    if (!bar || !isFinite(bar.open)) {
      this.el.innerHTML = `<div class="lg-title">${this.symbol}<span class="lg-tf">${this.tfLabel}</span></div>`;
      return;
    }
    const bull = bar.close >= bar.open;
    const col = bull ? "var(--bull)" : "var(--bear)";
    const chg = bar.close - bar.open;
    const pct = (chg / bar.open) * 100;
    const dec = chart.priceDecimals;
    const vol = isFinite(bar.volume) && bar.volume > 0 ? bar.volume.toLocaleString("en-US") : "—";
    this.el.innerHTML = `
      <div class="lg-title">${this.symbol}<span class="lg-tf">· ${this.tfLabel} · CME</span></div>
      <div class="lg-ohlc" style="color:${col}">
        <span><span class="lg-k">O</span> <b>${formatPrice(bar.open, dec)}</b></span>
        <span><span class="lg-k">H</span> <b>${formatPrice(bar.high, dec)}</b></span>
        <span><span class="lg-k">L</span> <b>${formatPrice(bar.low, dec)}</b></span>
        <span><span class="lg-k">C</span> <b>${formatPrice(bar.close, dec)}</b></span>
        <span><b>${chg >= 0 ? "+" : ""}${formatPrice(chg, dec)}</b> (${pct >= 0 ? "+" : ""}${pct.toFixed(2)}%)</span>
      </div>
      <div class="lg-ohlc" style="color:var(--text-mute)">
        <span><span class="lg-k">Vol</span> ${vol}</span>
        <span>${formatDateTime(bar.time)}</span>
      </div>`;
  }
}
